import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, withStyles, Tooltip } from '@material-ui/core';
import Slider from '../../../Social/NetflixSlider';
import styles from '../../../styles/browseStory.js';
import BookShareTable from '../Shared/BookShareTable';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getDatabank } from '../../../redux/actions';
import Select from 'react-select';
import BookShareCredentialsLogin from './BookShareCredentialsLogin';
import Download from '../Shared/Download'
import { addStoryToStudent } from '../../../redux/actions/platform/books.js'

let GradeLevelList = [
    { value: 0, label: 'K' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '+10'}
];

const rows = [
    { id: 'gradeLevel', label: <FormattedMessage id='General.gradeLevel' /> },
    { id: 'name', label: <FormattedMessage id='General.title' /> },
    { id: 'author', label: <FormattedMessage id='General.author' /> },
    { id: 'isbn', label: <FormattedMessage id='General.isbn' /> },
    { id: 'source', label: <FormattedMessage id='General.source' /> }
];

function DisplayStoryList({ id, databank, student, storyList, type, classes, dispatch, storyId, imported, user, closeWizard }) {
    const [noResultFound, setNoResultFound] = useState(false);
    const [dbank, setDbank] = useState([]);
    const [lexile, setLexile] = useState({
        value: 0,
        label: 'K'
    });
    const [loginRequired, setLoginRequired] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const [showCheckmark, setShowCheckmark] = useState(false)

    useEffect(() => {
        if (databank.length >  0) {
            let newDB = filterDB();
                if (user.type == "Individual" && user.hasBookShareCredentials == false) {
                    newDB = newDB.filter(data => data.source == "ObjectiveEd");
                }
            setDbank(newDB);
        }
    }, [databank, user])
    

    useEffect(() => {
        if (storyList.length) {
            setNoResultFound(true);
        }
    }, [storyList])

    useEffect(() => {
        if (type === 'LexileStory') {
            console.log('databank', databank);
        }
    }, [type])
    
    useEffect(() => {
        let newDB = filterDB();
        console.log(newDB);
        if (user.type == "Individual" && user.hasBookShareCredentials == false) {
            newDB = newDB.filter(data => data.source == "ObjectiveEd");
        }
        setDbank(newDB);
    }, [lexile])

    const filterDB = () => {
        let selectedValue = lexile.value
        let newDB = databank && databank.filter(db => {
            if(selectedValue === 10 ){
                return db.gradeLevel >= 10
            }
            else{
                return db.gradeLevel == selectedValue
            }
        })
        return newDB;
    }

    const importMany = async (list) => {
        setShowLoading(true);
        if (list && student) {
    
            const books = list.items;
            const studentId = student.id;
    
            const addBooksForStudent = (book) => {
                if (book.items && Array.isArray(book.items)) {
                    return Promise.all(book.items.map(subBook => addBooksForStudent(subBook)));
                } else {
                    console.log("Import Book (id - name):", book.id, " - ", book.name);
                    return dispatch(addStoryToStudent(studentId, book.id));
                }
            };
    
            await Promise.all(books.map(book => addBooksForStudent(book)));
    
            // hacked together visual indication of addBooks... call
            setTimeout(() => setShowCheckmark(true), 1000)
            setTimeout(() => setShowLoading(false), 1100) // just cleanup
        }
    };
    

    const RecomendList = (list, force) => {
        let styleRecommended = {};
        if ((user.type === "Individual" || user.type === "Teacher") && !user.hasBookShareCredentials && list.locked === 'Y') {
            styleRecommended = { pointerEvents: 'none', opacity: '0.2' }
        }
        return (
            <div style={{ backgroundColor: 'rgba(255,255,255,0.62)' }} key={list.name}>
                <Box sx={{ p: 2 }}>
                    <Typography variant='h4' component='h4' style={{ color: "#00729b" }}>
                        <b>{list.name}</b>
                        <Tooltip
                          title={<FormattedMessage id='Databanks.addAllSlider'/>}
                          enterDelay={300}
                          placement="right"
                        >
                            <span>
                                <Download
                                        // checked={
                                        //   (bookShareRequestBooks &&
                                        //     bookShareRequestBooks.data.some(
                                        //       (b) => b.id === story.id
                                        //     )) ||
                                        //   (books &&
                                        //     books.some(
                                        //       (b) => b.name === story.name && story.name != null
                                        //     ))
                                        // }
                                        checked={showCheckmark}
                                        loading={showLoading}
                                        onDownload={(e) => importMany(list, e)}
                                />   
                            </span>
                        </Tooltip>
                    </Typography>
                    <div style={{ position: 'relative' }}>
                        {(user.type === "Individual" || user.type === "Teacher") && !(user.hasBookShareCredentials) && (list.locked === 'Y') &&
                            <Button className={classes.bookshareLoginButton} variant='contained' onClick={() => handleBookshareLogin()}>
                                Login to Bookshare to Access More Content.</Button>}
                        <Box className={classes.recomendListBox} style={styleRecommended}>
                            {
                                <Slider>
                                    {list.items && list.items.length > 0 && list.items.map(storyItem => (
                                        <Slider.Item movie={storyItem} storyHeader={list.name} id={id} key={storyItem.id}>item1</Slider.Item>
                                    ))}
                                </Slider>
                            }
                        </Box>
                    </div>
                </Box>
            </div>
        )
    }

    const ReadingList = () => {
        return (
            <div style={{ minHeight: '395px', textAlign: 'center' }}>Reading List</div>
        )
    }
    
    const handleChangeLexileLevel = (e) => {
        console.log(e);
        setLexile(e.target.value);
    }
    const handleBookshareLogin = () => {
        setLoginRequired(true);
    }
    const closeLoginModal = () => {
        setLoginRequired(false);
    }


    return (
        <div
        // style={{ backgroundColor: '#d3e6ff' }}
        >
            {type === 'Recomendations' &&
                storyList.constructor === Array && storyList.length > 0 &&
                storyList.map((list, index) => {
                    // var force = false;
                    // if(index<=2) force = true;
                    if(user.hasBookShareCredentials){
                        return list.locked === 'Y' && RecomendList(list)
                    }
                    else{
                         return RecomendList(list)
                    }
                })
            }
            {
                type === 'LexileStory' &&
                databank.constructor === Array && databank.length > 0 &&
                <div>
                    <div className={classes.lexileWrap}>
                        <Select
                            styles={{
                                control: (styles) => ({ ...styles, minHeight: 56 }),
                            }}
                            className={classes.lexileSelect}
                            defaultValue={0}
                            menuPlacement='bottom'
                            // placeholder='Select lexile level'
                            maxMenuHeight={240}
                            value={lexile}
                            options={GradeLevelList}
                            onChange={(ev) => handleChangeLexileLevel({ target: { name: 'lexile', value: ev }})}
                        />
                    </div>
                    <BookShareTable
                        rows={rows}
                        data={dbank}
                        importSkill={null}
                        includeTitleImage={false}
                        imported={imported}
                        noResultFound={noResultFound}
                        lexileTabClicked={true}
                        storyId={storyId}
                        closeWizard={closeWizard}
                    />
                </div>

            }
            {
                type === 'StudentStory' &&
                ReadingList()
            }
            {loginRequired && <BookShareCredentialsLogin
                openLoading={loginRequired}
                exitFunc={closeLoginModal} />}
        </div>

    )
}

const mapState = ({ platform: { databank, student }, shared: { user } }) => {
    return {
        databank,
        student,
        user
    }
};

export default connect(mapState)(withStyles(styles)(DisplayStoryList));